function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "28",
  height: "26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.963 3.753C4.635-.183 10.097-1.072 13.995 1.37c3.9-2.441 9.358-1.552 12.033 2.38 1.734 2.55 2.078 5.938 1.094 8.997l-.003.01-.004.011c-2.098 6.052-7.684 10.015-12.58 13.061a1 1 0 01-1.043.009C8.543 22.874 2.97 18.777.885 12.769l-.003-.01-.004-.011C-.105 9.69.233 6.302 1.963 3.753zM19.29 5.452a1 1 0 00-.609 1.905 2.709 2.709 0 011.864 2.36 1 1 0 001.993-.167 4.709 4.709 0 00-3.248-4.099z",
  fill: "#313D53"
})));